import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import './workingTemplate.scss';
import TemplateCard from './templateCard/templateCard';
import { Link } from 'react-router-dom';
import HolidaySelectionModal from './holidaySelectionModal/holidaySelectionModal';
const WorkingTemplate = () => {
    const data = '';
    return (
        <WithSideBarAndNavBar>
            <div className="workingTemplate">
                <div className="workingTemplateTitleBar">
                    <div className="header">근로템플릿 관리</div>
                    <Link to="/add-working-template" className="button">
                        +추가하기
                    </Link>
                </div>
                <div className="container">
                    <div className="cardWrapper">
                        <TemplateCard
                            type={'hourly'}
                            name={'템플릿명'}
                            allowance={'주휴수당 자동 가산 / 휴계시간 자동 차감 / 추가야간휴일 수당 50% 자동 가산 '}
                            report={'4대보험(국민연금,건강보험, 고용보험, 산재보험)'}
                            amount={9.16}
                        />
                    </div>

                    <div className="cardWrapper">
                        <TemplateCard
                            type={'weekly'}
                            name={'템플릿명'}
                            allowance={'주휴수당 자동 가산 / 휴계시간 자동 차감 / 추가야간휴일 수당 50% 자동 가산 '}
                            report={'4대보험(국민연금,건강보험, 고용보험, 산재보험)'}
                            amount={9.16}
                        />
                    </div>
                    <div className="cardWrapper">
                        <TemplateCard
                            type={'monthly'}
                            name={'템플릿명'}
                            allowance={'주휴수당 자동 가산 / 휴계시간 자동 차감 / 추가야간휴일 수당 50% 자동 가산 '}
                            report={'4대보험(국민연금,건강보험, 고용보험, 산재보험)'}
                            amount={9.16}
                        />
                    </div>
                    <div className="emptyTemplateCard"> </div>
                    {/* <HolidaySelectionModal
                        header="추가완료"
                        description={'근로템플릿이 추가되었습니다.'}
                        buttonText={'확인'}
                        title={'addition'}
                    />
                    <HolidaySelectionModal
                        header="수정완료"
                        description={'근로템플릿이 수정되었습니다.'}
                        buttonText={'확인'}
                        title={'modification'}
                    /> */}
                </div>
            </div>
        </WithSideBarAndNavBar>
    );
};

export default WorkingTemplate;
